import { createSlice } from "@reduxjs/toolkit";
import { getReferralReward, addUserRequest, getProgram, addFriendsDetail, addFriendsProgram } from './thunk';
export const initialState = {
  referralReward: [],
  referredUser: [],
  referredUserYetToJoin: [],
  enrolledUser: [],
  program: [],
  loading: false,
  error: {}
};

const ReferralReward = createSlice({
  name: 'ReferralReward',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getReferralReward.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getReferralReward.fulfilled, (state, action) => {
      state.referralReward = action.payload.ReferralReward;
      state.referredUser = action.payload.ReferredUser;
      state.referredUserYetToJoin = action.payload.ReferredUserYetToJoin;
      state.enrolledUser = action.payload.EnrolledUser;
      state.loading = false;
    });

    builder.addCase(getReferralReward.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addUserRequest.fulfilled, (state, action) => {
      // state.referralReward = action.payload;
    });

    builder.addCase(addUserRequest.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getProgram.fulfilled, (state, action) => {
      state.program = action.payload;
    });

    builder.addCase(getProgram.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addFriendsDetail.fulfilled, (state, action) => {
      state.referredUser = [...action.payload, ...state.referredUser].map((item, i) => ({...item, SerialNo: i + 1}))
    });

    builder.addCase(addFriendsDetail.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addFriendsProgram.fulfilled, (state, action) => {
      const ids = action.payload.map(item => item.ID);

      const referredUserObj = action.payload.reduce((acc, item) => {
        acc[item.ID] = item;
        return acc;
      }, {});

      const updatedReferredUser = state.referredUser.map(item =>
        ids.includes(item.ID) ? referredUserObj[item.ID] : item
      );

      state.referredUser = updatedReferredUser.map((item, index) => ({
        ...item,
        SerialNo: index + 1,
      }));
    });

    builder.addCase(addFriendsProgram.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default ReferralReward.reducer;